import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

export const data = {
  labels: ['Boys', 'Girls'],
  datasets: [
    {
      label: 'Rent Payments',
      data: [120, 190],
      backgroundColor: [
        'rgba(255, 99, 132, 0.2)',
        'rgba(54, 162, 235, 0.2)',
      ],
      borderColor: [
        'rgba(255, 99, 132, 1)',
        'rgba(54, 162, 235, 1)',
      ],
      borderWidth: 1,
    },
  ],
};

export default function DoughnutChart(props) {
  return (
    <Doughnut
      data={{
        labels: props.label,
        datasets: props.data,
      }}
      width={50}
    />
  );
}